import type { Dayjs } from 'dayjs';
import { DatePicker } from 'antd';
import { cn } from 'cn';
import { DATE_FORMAT } from '@/std/const/date';
import { isTouchDevice } from '@/std/platform';
import { getValue, type PickProps } from './util';

export function PickDate({
    className,
    disabled,
    format = DATE_FORMAT,
    placeholder = 'Selecionar data',
    value,
    onChange,
}: PickProps) {
    const handleChange = (date: Dayjs | null, dateString: string | string[] | null): void => {
        const str = Array.isArray(dateString) ? dateString.join() : dateString;
        onChange?.(str, date);
    };

    return (
        <DatePicker
            allowClear={true}
            className={cn('w-full', className)}
            disabled={disabled}
            format={format}
            inputReadOnly={isTouchDevice()}
            onChange={handleChange}
            placeholder={placeholder}
            value={getValue(value, format)}
        />
    );
}
